import React from "react";
import ConfidenceLabel from "../../shared/ConfidenceLabel";

const Tab3ModeVieFamille = ({ form, onChange, getConfidence }) => {
  const gc = getConfidence || (() => ({ exists: false }));

  return (
    <div className="om-fields">

      <div className="om-field-group">
        <label>Type de logement <ConfidenceLabel confidence={gc("type_logement")} /></label>
        <select value={form.type_logement ?? ""} onChange={(e) => onChange("type_logement", e.target.value)}
          style={{ borderColor: gc("type_logement").color || undefined }}>
          <option value="">—</option>
          <option value="villa">Villa</option>
          <option value="appartement">Appartement</option>
          <option value="case">Case</option>
          <option value="cour commune">Cour commune</option>
        </select>
      </div>

      <div className="om-row">
        <div className="om-field-group om-field-group--small">
          <label>Nombre de pièces <ConfidenceLabel confidence={gc("nb_pieces")} /></label>
          <input type="number" min="0" placeholder="Ex : 3" value={form.nb_pieces ?? ""}
            onChange={(e) => onChange("nb_pieces", e.target.value)}
            style={{ borderColor: gc("nb_pieces").color || undefined }} />
        </div>
        <div className="om-field-group om-field-group--small">
          <label>Personnes dans la maison <ConfidenceLabel confidence={gc("nb_personnes")} /></label>
          <input type="number" min="0" placeholder="Ex : 7" value={form.nb_personnes ?? ""}
            onChange={(e) => onChange("nb_personnes", e.target.value)}
            style={{ borderColor: gc("nb_personnes").color || undefined }} />
        </div>
      </div>

      <div className="om-row">
        <div className="om-field-group">
          <label>Adduction d'électricité <ConfidenceLabel confidence={gc("electricite")} /></label>
          <select value={form.electricite ?? ""} onChange={(e) => onChange("electricite", e.target.value)}
            style={{ borderColor: gc("electricite").color || undefined }}>
            <option value="">—</option>
            <option value="oui">Oui</option>
            <option value="non">Non</option>
          </select>
        </div>
        <div className="om-field-group">
          <label>Adduction d'eau courante <ConfidenceLabel confidence={gc("eau_courante")} /></label>
          <select value={form.eau_courante ?? ""} onChange={(e) => onChange("eau_courante", e.target.value)}
            style={{ borderColor: gc("eau_courante").color || undefined }}>
            <option value="">—</option>
            <option value="oui">Oui</option>
            <option value="non">Non</option>
          </select>
        </div>
      </div>

      {form.eau_courante === "oui" && (
        <div className="om-field-group">
          <label>Emplacement de l'eau <ConfidenceLabel confidence={gc("eau_emplacement")} /></label>
          <select value={form.eau_emplacement ?? ""} onChange={(e) => onChange("eau_emplacement", e.target.value)}
            style={{ borderColor: gc("eau_emplacement").color || undefined }}>
            <option value="">—</option>
            <option value="interieur">À l'intérieur de la maison</option>
            <option value="cour">Dans la cour</option>
          </select>
        </div>
      )}

      {form.eau_courante === "non" && (
        <div className="om-field-group">
          <label>Source d'approvisionnement <ConfidenceLabel confidence={gc("source_eau")} /></label>
          <select value={form.source_eau ?? ""} onChange={(e) => onChange("source_eau", e.target.value)}
            style={{ borderColor: gc("source_eau").color || undefined }}>
            <option value="">—</option>
            <option value="puits">Eau de puits</option>
            <option value="marigot">Eau de marigot ou rivière</option>
          </select>
        </div>
      )}

      <div className="om-divider" />

      <div className="om-row">
        <div className="om-field-group">
          <label>Revenus de la famille <ConfidenceLabel confidence={gc("revenus")} /></label>
          <input type="text" placeholder="Montant" value={form.revenus ?? ""}
            onChange={(e) => onChange("revenus", e.target.value)}
            style={{ borderColor: gc("revenus").color || undefined }} />
        </div>
        <div className="om-field-group">
          <label>Périodicité <ConfidenceLabel confidence={gc("revenus_periodicite")} /></label>
          <select value={form.revenus_periodicite ?? ""} onChange={(e) => onChange("revenus_periodicite", e.target.value)}
            style={{ borderColor: gc("revenus_periodicite").color || undefined }}>
            <option value="">—</option>
            <option value="journaliers">Journaliers</option>
            <option value="mensuels">Mensuels</option>
            <option value="annuels">Annuels</option>
          </select>
        </div>
      </div>

      <div className="om-field-group">
        <label>Dépense alimentaire journalière de la famille pour le repas quotidien <ConfidenceLabel confidence={gc("depense_alimentaire")} /></label>
        <input type="text" placeholder="Montant journalier" value={form.depense_alimentaire ?? ""}
          onChange={(e) => onChange("depense_alimentaire", e.target.value)}
          style={{ borderColor: gc("depense_alimentaire").color || undefined }} />
      </div>

      <div className="om-row">
        <div className="om-field-group om-field-group--small">
          <label>Nombre à charge <ConfidenceLabel confidence={gc("nb_charge")} /></label>
          <input type="number" min="0" placeholder="Nb" value={form.nb_charge ?? ""}
            onChange={(e) => onChange("nb_charge", e.target.value)}
            style={{ borderColor: gc("nb_charge").color || undefined }} />
        </div>
        <div className="om-field-group">
          <label>Niveau socio-économique <ConfidenceLabel confidence={gc("niveau_socio")} /></label>
          <select value={form.niveau_socio ?? ""} onChange={(e) => onChange("niveau_socio", e.target.value)}
            style={{ borderColor: gc("niveau_socio").color || undefined }}>
            <option value="">—</option>
            <option value="bas">Bas</option>
            <option value="modeste">Modeste</option>
            <option value="eleve">Élevé</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default Tab3ModeVieFamille;